// removed by extract-text-webpack-plugin
module.exports = {"container":"_2upqlAfn0wo3QkJgzCG7fQ","pending":"_1eAJffWQxSDnd4joB-hw19"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Document/Page/Field/Show/Signature/styles.css
// module id = 2918
// module chunks = 0